import tokens from "./tokens.json";

// V2 is light mode only. Every colour, size and type step comes from
// tokens.json, which is copied verbatim from docs/v2/tokens.md. Nothing is
// typed by hand in a component.
export { tokens };
export const colors = tokens.light;
export const { serif, sans } = tokens.font;

/** 25 Aug. A past date is just the date, with no label on it. */
export const shortDate = (iso: string | null) =>
  iso
    ? new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "UTC" })
    : "";

export const longDate = (iso: string) =>
  new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-GB", {
    weekday: "long", day: "numeric", month: "long", timeZone: "UTC",
  });

/** Every date in this app is Europe/Berlin, matching the server. */
export const todayISO = () =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Berlin", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());

/** The one rule for the serif: heavy title, screen title, sheet title, the question. Everything else is sans. */
export const captionStyle: React.CSSProperties = {
  fontFamily: sans, fontSize: tokens.type.caption.size, letterSpacing: tokens.type.caption.letterSpacing,
  textTransform: "uppercase", fontWeight: tokens.type.caption.weight, color: colors.ink2,
};

export const addDays = (iso: string, n: number) => {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

/** Whole days from one date to another. */
export const daysBetween = (a: string, b: string) =>
  Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 86_400_000);

/** Sat 10 Oct */
export const dayLabel = (iso: string) =>
  new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" });
